<div 
  #containerRef
  class="image-tag-container"
  [class]="class"
  [style.width.px]="width"
  [style.height.px]="height">
  <canvas 
    #canvasRef
    class="image-tag-canvas"
    [class.loaded]="imageLoaded"
    [attr.aria-label]="alt"
    [attr.role]="'img'">
  </canvas>
  <div *ngIf="!imageLoaded && src" class="image-tag-loading">
    <div class="spinner"></div>
  </div>
  <div *ngIf="!src" class="image-tag-placeholder">
    <svg class="placeholder-icon" fill="none" stroke="currentColor" viewBox="0 0 24 24">
      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z" />
    </svg>
  </div>
</div>



